
<style type="text/css">

.recent-orders-table{
	width: 100%;
	border-collapse: separate;
	text-align: left;
	border-spacing: 0 10px;
	border-radius: 10px;
}
.recent-orders-table thead{
	/*background-color: #EBEAEA;*/
	font-style: normal;
	font-weight: bold;
	font-size: 13px;
	line-height: 18px;
	letter-spacing: 0.015em;
	color: #333232;
	border-radius: 10px;

}
.recent-orders-table th,
.recent-orders-table td{
	padding: 10px;
}
.recent-orders-table tbody tr{
	box-shadow: 0px 5px 10px rgba(157, 149, 149, 0.25);
	border-radius: 10px;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 18px;
	letter-spacing: 0.015em;
	color: #333232;
}

</style>
<template>
	<div class="custome-header-bg">
		<p class="page-title text-left">{{$lang.RECENT_ORDERS.toUpperCase()}}</p>
		<table class="recent-orders-table">
			<thead> 
				<tr >
					<th v-for="(item,i) in headers" :key="i">{{item.text}}</th>
				</tr>
			</thead>
			<tbody v-if="shipment_list.length!=0">

				<tr v-for="(item,i) in shipment_list" :key="i" 
				class="cursor-pointer" @click="gotoShipmentDetails(item)" >
				<td>{{item.shipment_id}}</td>
				<td>
					<div>
						<p>{{item.retailer_firm_name}}</p>
						<p>{{$lang.MOBILE_PREFIX}}{{item.retailer_mobile_number}}</p>
					</div>
				</td>
				<td>{{item.shipment_amount}}</td>
				<td>{{item.challan_number}}</td>
				<td>	
					<span  :class="getClass(item.shipment_status)">{{item.shipment_status}}</span>
				</td>
				<td>	
					<v-btn small fab text @click="gotoShipmentDetails(item)">	
						<img src="@/assets/arrow-right.svg" alt="">	
					</v-btn>
				</td>
			</tr>
		</tbody>
		<!-- for empty state  -->
		<tbody v-else>
			<tr>
				<td colspan="4" class="text-center">
					<empty-list :message="$lang.EMPTY_SHIPMENTS"/>
				</td>
			</tr>
		</tbody>
	</table>
</div>
</template>


<script>
export default {
	props:['shipment_list'],
	data () {
		return {
			disable_pagination:true,
			sortable:true,
			headers: [
			{ text: "Shipment ID",class:""},
			{ text: "Retailer Info",class:""},
			{ text: "Challan",class:""},
			{ text: "Amount",class:""},
			{ text: "Status",class:""},
			{ text: "",class:""},
			],
		}
	},
	methods:{
		getClass(shipment_status){
			let cl =shipment_status.replace(" ", '-');
			cl =cl.replace(" ", '-');
			cl=cl.toLowerCase()

			return cl
		},
	}
}
</script>